export default __webpack_public_path__ + "static/media/num-05.9d8a3b21.svg";